import { Component } from '@angular/core';
import { LocalOfficeSandbox } from '../../../../core/sandboxes/local-office.sandbox';
import { LocalOffice } from '../../../../core/store/admin/local-office/local-office.interface';
import { NotificationService } from '../../../../core/services/notification.service';
import { Modal } from '../../../../core/store/notification/notification.interface';
import { fadeInAnimation } from '../../../../animations';
import { Destroyable } from '@dlw-int-mwi/eps-common';

@Component({
  selector: 'app-local-office',
  templateUrl: './local-office.container.html',
  styleUrls: ['./local-office.container.scss'],
  animations: [fadeInAnimation],
})
export class LocalOfficeContainer extends Destroyable {
  localOffices: LocalOffice[] = [];
  localOfficeToEdit ?: LocalOffice;
  constructor(public sandbox: LocalOfficeSandbox, private notificationService: NotificationService) {
    super();
    sandbox.editableLocalOffices$.pipe(this.takeUntilDestroyed()).subscribe(localOffices => this.localOffices = localOffices);
    sandbox.load();
  }

  editLocalOffice(localOffice: LocalOffice) {
    this.localOfficeToEdit = localOffice;
  }

  async save(localOffice: LocalOffice) {
    try {
      const body = {
        ...localOffice,
        contacts: localOffice.contacts
          .filter(contact => contact.enabled) // remove disabled contacts
          .map(({enabled, ...contact}) => contact), // remove enabled flag
      };
      await this.sandbox.save(body);
      let notification: Partial<Modal> = {
        type: 'success',
        messageCode: 'ADMIN.LOCAL_OFFICE.MESSAGES.SAVE_SUCCESS',
        titleCode: 'ADMIN.LOCAL_OFFICE.MESSAGES.SAVE_TITLE',
      };
      this.notificationService.showModal(notification);
    } catch (e) {
      let notification: Partial<Modal> = {
        type: 'error',
        messageCode: 'ADMIN.LOCAL_OFFICE.MESSAGES.SAVE_FAIL',
        titleCode: 'ADMIN.LOCAL_OFFICE.MESSAGES.SAVE_TITLE',
      };
      this.notificationService.showModal(notification);
    }
  }
}
